<template>
    <div class="row" v-if="flightHours">

        <div class="col-5">
            <p>
                <i class="material-icons" style="position:relative;top:5px;">location_on</i>
                <span class="font-weight-bold">{{ location }}</span>
            </p>
            <p>
                <i class="material-icons" style="position:relative;top:5px;">flight_land</i>
                <span class="font-weight-bold">
                    {{ lang.polaris.dashboard.tag_landing }}: 
                </span>
                {{ tagLandingDetails() }}
            </p>
        </div>
        <div class="col-7">
            <div v-for="category in flightHoursNew" :key="category.global.key">
                <div v-if="category.global.display">
                    <h5 :class="catTitleClass(category.global)">{{ lang.polaris.flight_hours[category.global.key] }}</h5>
                    <div :class="'mb-0 progress progress-line-'+catColor(category.global)">
                        <div :class="'progress-bar progress-bar-'+catColor(category.global)" aria-valuemin="0" aria-valuemax="100" 
                            :aria-valuenow="catProgressValue(category.global)" :style="'width:'+catProgressValue(category.global)+'%'">
                        </div>
                    </div>
                    <p class="mb-1"><small>{{ catDetails(category.global) }}</small></p>

                    <div class="mb-3" v-if="Object.keys(category.series).length">
                        <small v-for="serie in category.series" :key="serie.serieKey" 
                            style="background-color:#ddd;padding:2px 4px;" class="mr-1">
                            {{ serieDetails(serie) }}
                        </small>
                    </div>
                    <div class="mb-3" v-else></div>
                </div>
            </div>
            <h5 class="mb-0">SKILL TESTS</h5>
            <p class="mb-1"><small>{{ skillsTestDetails() }}</small></p>
        </div>

    </div>
</template>

<script>
    export default {
    
        props: {
            id: null,
            bus: null
        },
    
        data: function() {
            return {
                lang: lang,
                flightHours: null,
                flightHoursNew: null,
                location: null,
                color: null
            }
        },

        created: function() {
            this.bus.$on(this.id+'-modal-open', this.opened);
        },

        methods: {
        
            opened: function(event) {
                this.flightHours = event.data.flight_hours;
                this.flightHoursNew = [];
                this.location = event.data.location;

                // Total hours color
                this.color = 'success';
                for (var index in this.flightHours) {
                    var item = this.flightHours[index];

                    // New hours format, including series.
                    if (typeof item.global === "undefined") {
                        var global = item;
                        this.flightHoursNew.push({global: item, series: {}});
                    } else {
                        var global = item.global;
                        this.flightHoursNew.push(item);
                    }

                    // Global color.
                    if (global.display && global.key != 'total' && global.key != 'remedial_flight' && global.key != 'remedial_simu' && global.time_spent < global.duration) {
                        this.color = 'danger';
                    } 
                }
            },

            catTitleClass: function(category) {
                return category.key == 'total' || category.key == 'remedial_flight' || category.key == 'remedial_simu' ? 'mb-1 font-weight-bold' : 'mb-1';
            },

            catColor: function(category) {
                if (category.key == 'total') return this.color;
                return this.catProgressValue(category) == 100 ? 'success' : 'danger';
            },

            catProgressValue: function(category) {
                if (category.duration == 0) return 100;
                var percent = Math.floor(category.time_spent * 100 / category.duration);
                return Math.min(percent, 100);
            },

            catDetails: function(category) {
                var res = this.round(category.time_spent) + '/' + this.round(category.duration) + ' ' + this.lang.polaris.flight_hours.hour_s_lc;
                res += ', '+category.completed+'/'+category.count+' '+this.lang.polaris.flight_hours.session_s_lc;
                return res;
            },

            serieDetails: function(serie) {
                var title = lang.polaris.options['serie_' + serie.serieKey];
                return title + ': ' + this.round(serie.time_spent) + '/' + this.round(serie.duration) + 'h';
            },

            round(number) {
                return Math.round(number * 100) / 100
            },

            tagLandingDetails: function() {
                if (!this.flightHoursNew) return '';
                for(var i = 0; i < this.flightHoursNew.length; i += 1) {
                    if (this.flightHoursNew[i].global.key === 'tag_landing') {
                        return this.flightHoursNew[i].global.tag_landing;
                    }
                }
                return this.lang.polaris.dashboard.unknown;
            },

            skillsTestDetails: function() {
                if (!this.flightHoursNew) return 0 + ' ' + this.lang.polaris.flight_hours.hour_s_lc;
                for(var i = 0; i < this.flightHoursNew.length; i += 1) {
                    if (this.flightHoursNew[i].global.key === 'skills_test') {
                        return this.flightHoursNew[i].global.duration + ' ' + this.lang.polaris.flight_hours.hour_s_lc;
                    }
                }
                return 0 + ' ' + this.lang.polaris.flight_hours.hour_s_lc;
            }
        }

    }
</script>
